const Pagination = {
    page: 1,
    total: 0,
    from: null,
    to: null,
    current_page: null,
    last_page: null,
    next_page_url: null,
    prev_page_url: null,
    data: [],
    per_page: 100,
}

export default Pagination